import './add.scss';
import { Page } from '../../../../../components/page/page';
import { message, Select } from 'antd';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { DefaultOptionType } from 'antd/es/select';
import { getViaAuth, responseValidator } from '../../../../../apis/api';
import { PaginationList, User } from '../../../../../core/domain';
import { API } from '../../../../../apis';
import { Input } from '../../../../../components/input/input';
import { Card } from '../../../../../components/card/card';
import { Button, buttonType } from '../../../../../components/button/button';
import { AddUserSavedIBansBody } from '../../../../../core/domain/users-saved-ibans/users-saved-ibans';
import { addIBan } from '../../../../../core/repositories/users-saved-ibans';
import { Link } from 'react-router-dom';

export const AddIBan = () => {
    const [users, setUsers] = useState<DefaultOptionType[]>([]);
    const [usersLoading, setUsersLoading] = useState<boolean>(false);
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const [data, setData] = useState<AddUserSavedIBansBody>();
    const searchTimeout = useRef<NodeJS.Timeout | null>(null);

    const getAllUsers = async (query: string) => {
        setUsersLoading(true);
        await getViaAuth<PaginationList<User>>(API.users.getAll + `/${1}/${10}${query && `?keywords=${query}`}`).then(
            (response: any) => {
                setUsersLoading(false);
                const arr = [];
                if (responseValidator(response.status)) {
                    if (response.data.items) {
                        response.data.items.forEach((e) =>
                            arr.push({
                                label: e.fullName.startsWith(' ') || !e.fullName ? e.phoneNumber : e.fullName,
                                value: e.id,
                            }),
                        );
                        setUsers(arr);
                    }
                }
            },
        );
    };

    const onSearchChange = (value: string) => {
        if (value !== '' && value.length > 0) {
            if (searchTimeout.current) {
                clearTimeout(searchTimeout.current);
            }

            searchTimeout.current = setTimeout(() => {
                getAllUsers(value);
            }, 1000);
        }
    };

    const handleAddIBan = () => {
        addIBan(setButtonLoading, data, () => message.success('شماره شبا با موفقیت افزوده شد'));
    };

    useEffect(() => {
        return () => {
            if (searchTimeout.current) {
                clearTimeout(searchTimeout.current);
            }
        };
    }, []);

    return (
        <Page className={'pmx-add-iban'}>
            <Card title={'اضافه کردن شماره شبا'}>
                <div className="select">
                    <label htmlFor="message">کاربر صاحب حساب</label>
                    <Select
                        loading={usersLoading}
                        allowClear
                        value={data?.userId}
                        placeholder="کاربر را جستجو کنید"
                        onChange={(value, options) => {
                            setData({
                                ...data,
                                userId: value,
                            });
                        }}
                        options={users}
                        showSearch
                        onSearch={(value) => onSearchChange(value)}
                        filterOption={false}
                    />
                </div>
                <Input
                    value={data?.label}
                    label={'عنوان شماره شبا'}
                    placeholder={'عنوان شماره شبا'}
                    onChange={(e) => setData({ ...data, label: e.target.value })}
                />
                <Input
                    value={data?.iBan}
                    label={'شماره شبا بدون IR'}
                    placeholder={'شماره شبا بدون IR'}
                    onChange={(e) => setData({ ...data, iBan: e.target.value })}
                    maxLength={24}
                />

                <div className={'buttons'}>
                    <Button type={buttonType.success} text={'افزودن'} loading={buttonLoading} onClick={handleAddIBan} />
                    <Link to={'/dashboard/users-saved-ibans'} target={'_self'}>
                        <Button type={buttonType.outlined} text={'بازگشت'} />
                    </Link>
                </div>
            </Card>
        </Page>
    );
};
